module.exports = __webpack_public_path__ + "img/Norsk-billedbog-for-børn_Bilde-av-bjørner.60757299.jpg";